import { createUseStyles } from 'react-jss'

export default createUseStyles({
  flowContainer: {
    width: '100%',
    maxWidth: '100%',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '16px 8px',
    boxSizing: 'border-box'
  },
  emptyState: {
    textAlign: 'center',
    color: '#5f6368',
    fontStyle: 'italic',
    padding: 60
  }
})
